import { Component, Input, OnInit } from '@angular/core';
import { WorkProjectsService, WorkTask } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-baustellen-dispo',
  templateUrl: './ax-project-baustellen-dispo.component.html',
  styleUrls: ['./ax-project-baustellen-dispo.component.scss'],
})
export class AxProjectBaustellenDispoComponent implements OnInit {
  @Input() projectId: number;
  public tasks: WorkTask[] = [];
  public accordionStates: any = {};

  constructor(
    private readonly axProjectsService: WorkProjectsService,
  ) {
  }

  ngOnInit() {
    this.axProjectsService.projectsV1ControllerGetBaustellenDispoTasksForProject({ id: this.projectId })
      .subscribe({
        next: tasks => {
          this.tasks = tasks;
        },
      });
  }
}
